import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcTextFieldComponent} from './ac-text-field.component';
import {MatInputModule} from '@angular/material/input';
import {InfraPipesModule} from "../../pipes/infra.pipes.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        InfraPipesModule,
    ],
    declarations: [
        AcTextFieldComponent,
    ],
    entryComponents: [
        AcTextFieldComponent,
    ],
    exports: [
        AcTextFieldComponent,
    ]
})
export class AcTextFieldModule {
}
